module.exports = __webpack_public_path__ + "img/order_status_daiyijia@2x.d5e45c6e.png";